import React from 'react';
import {connect} from 'react-redux';
import numeral from 'numeral';

import Meta               from 'app/components/common/meta';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';

import NonprofitCard      from 'app/components/nonprofits/nonprofit-card';
import StandardInput from 'app/components/common/standard-input';
import MillieApi from 'app/apis/millie';

class PageSearchTest extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      inputStr: '',
      searchStr: null,
      // startAt: 0,

      v1Pending: false,
      v1Results: null,
      v1Error: false,
      v1EndAt: null,

      v2Pending: false,
      v2Results: null,
      v2Error: false,
      v2EndAt: null,
    };

    this.startAt = 0;

    this.onChangeInputStr = this.onChangeInputStr.bind(this);
    this.onKeyDownInputStr = this.onKeyDownInputStr.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
  }

  onChangeInputStr(event) {
    const inputStr = event.target.value;
    this.setState({inputStr});
  }

  onKeyDownInputStr(event) {
    const isEnter = event.key === 'Enter';
    if (isEnter) {
      this.search();
    }
  }

  onClickSearch() {
    this.search();
  }

  search() {
    const pageSize = 100;
    const searchStr = this.state.inputStr;
    const startAt = new Date().getTime();
    this.startAt = startAt;
    this.setState({
      searchStr,
      v1Pending: true, v1Results: null, v1Error: false, v1EndAt: null,
      v2Pending: true, v2Results: null, v2Error: false, v2EndAt: null,
    });

    MillieApi.nonprofitsSearch({search: searchStr, pageSize, forceV1: true, skipCache: true})
      .then((v1Results) => {
        if (this.startAt !== startAt) return;
        this.setState({v1Results, v1Pending: false, v1EndAt: new Date().getTime()});
      })
      .catch(() => {
        if (this.startAt !== startAt) return;
        this.setState({v1Pending: false, v1EndAt: new Date().getTime(), v1Error: true});
      });

    MillieApi.nonprofitsSearch({search: searchStr, pageSize, skipCache: true})
      .then((v2Results) => {
        if (this.startAt !== startAt) return;
        this.setState({v2Results, v2Pending: false, v2EndAt: new Date().getTime()});
      })
      .catch(() => {
        if (this.startAt !== startAt) return;
        this.setState({v2Pending: false, v2EndAt: new Date().getTime(), v2Error: true});
      });
  }

  get count() {
    const {v1Results, v2Results} = this.state;
    return Math.max(...[v1Results, v2Results].map(res => res?.nonprofits?.length || 0));
  }

  renderResults(pending, results, error, endAt) {
    if (error) {
      return <p>Oops! Something went wrong.</p>;
    }
    if (pending) {
      return <p>Searching...</p>;
    }
    if (!results) return null;
    const durMs = endAt - this.startAt;
    const count = results.pagination?.resultCount || '?';
    const nps = results.nonprofits;

    return (
      <div>
        <p>Found {numeral(count).format('0,0')} results in {numeral(durMs / 1000).format('0.00')}s.</p>
        <div className="_flex _col _gap-24 _justify-start _align-stretch _mt-24">
          {nps.map((np) => {
            return (
              <NonprofitCard key={np.id} nonprofit={np} small />
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const {v1Pending, v1Results, v1Error, v1EndAt, v2Pending, v2Results, v2Error, v2EndAt} = this.state;
    const showSearchStr = this.state.searchStr != null;

    return (
      <MainLayout className="page-srchv2">
        <Meta title={`Search Test | Millie`} />
        <div className="widther">

          <div style={{maxWidth: 600}}>
            <h1 className="_mt-96 _mb-12">Search Test</h1>
            <p>Compare the new search function (right) to our current search function (left).</p>

            <div className="_mt-48 _flex _align-start _justify-start _gap-12">
              <StandardInput name="search" onChange={this.onChangeInputStr} value={this.state.inputStr} label="Search nonprofits..." onKeyDown={this.onKeyDownInputStr} className="_flex-1" />
              <button className="btn blue" onClick={this.onClickSearch}>Search</button>
            </div>

            {showSearchStr && (
              <h1 className="_mt-96 _mb-12">{`Results for "${this.state.searchStr || '*'}":`}</h1>
            )}
          </div>

          <div className="_flex _row _gap-0 _justify-start _align-start _mb-96 _mt-48">
            <div className="_flex-1">
              <h2 className="_mt-0 _mb-12">Current (Postgres)</h2>
              {this.renderResults(v1Pending, v1Results, v1Error, v1EndAt)}
            </div>
            <div className="" style={{marginTop: 80}}>
              {(new Array(this.count).fill('')).map((foo, i) => {
                return (
                  <div key={i} className="_mb-24 _flex _justify-center _align-center _clr-slate" style={{height: 136, width: 96}}>{`#${i+1}`}</div>
                );
              })}
            </div>
            <div className="_flex-1">
              <h2 className="_mt-0 _mb-12">New (Typesense)</h2>
              {this.renderResults(v2Pending, v2Results, v2Error, v2EndAt)}
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageSearchTest);
